import React from 'react';
import Dialog from 'seedly-component-library/dialog';
import { rewardOnboarding } from 'theme';
import Image from 'next/image';

const WhatModal = props => {
  const { isOpen, setModalOpen } = props;

  return (
    <Dialog
      isOpen={isOpen}
      headerTitle="What are Seeds, Tiers & Credits?"
      onCloseClick={() => setModalOpen(false)}
      widthSize="sm"
    >
      <div className="flex flex-col w-full gap-4 overflow-auto h-[95vh] lg:h-[85vh]">
        <p className="text-base font-bold">Tiers & Rewards</p>
        <p>
          Join the Rewards Programmes to grow your tiers and earn rewards at the
          same time!{' '}
        </p>
        <div>
          <Image
            src={rewardOnboarding.rewardOverview}
            height={339}
            width={448}
          />
        </div>
        <div>
          <Image src={rewardOnboarding.tierSeed} height={339} width={448} />
        </div>
        <div>
          <Image src={rewardOnboarding.redeemCredit} height={256} width={448} />
        </div>
      </div>
    </Dialog>
  );
};

export default WhatModal;
